module.exports = __webpack_public_path__ + "static/media/em.928c3287.svg";